export default __webpack_public_path__ + "static/Cabin-Regular-f54a520853e3c54bd448c7d383eaff05.ttf";